
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM6.284 9.342a1 1 0 01.696-1.231h.002l.003-.002c.141-.037.285-.07.428-.1.264-.054.64-.122 1.114-.18.945-.118 2.278-.2 3.854-.062 1.577.138 2.875.45 3.786.73.455.14.815.272 1.065.372.137.054.274.11.407.174.488.232.706.846.473 1.334a1 1 0 01-1.332.472l-.01-.005a6.11 6.11 0 00-.278-.117 12.168 12.168 0 00-.913-.319c-.8-.246-1.96-.525-3.372-.649a16.428 16.428 0 00-3.433.054c-.415.052-.74.11-.955.155a6.12 6.12 0 00-.294.067l-.01.003a1 1 0 01-1.23-.696zm2.066 4.954a1 1 0 00.724 1.864l.011-.004.094-.028c.093-.026.249-.064.464-.098.431-.069 1.107-.125 2.02-.045.912.08 1.568.252 1.98.395a4.23 4.23 0 01.527.22l.01.007a1 1 0 001.038-1.71l-.002-.001-.004-.003a2.62 2.62 0 00-.266-.14 6.199 6.199 0 00-.65-.264c-.563-.194-1.38-.402-2.46-.496-1.08-.095-1.92-.032-2.507.061-.293.047-.522.101-.686.147a3.814 3.814 0 00-.287.092l-.003.002H8.35zm-1.34-1.914a1 1 0 01.74-1.205h.005l.098-.022a11.813 11.813 0 011.118-.157c.748-.07 1.815-.108 3.127.006 1.311.115 2.356.339 3.081.537a11.808 11.808 0 011.074.349l.092.038h.003l.002.002a1 1 0 01-.793 1.836l-.005-.002a4.448 4.448 0 00-.201-.076 9.787 9.787 0 00-.7-.218c-.622-.17-1.548-.37-2.727-.473a15.522 15.522 0 00-2.769-.008 9.846 9.846 0 00-.9.125 1.99 1.99 0 00-.038.008l-.005.001a1 1 0 01-1.202-.74z"}})])
          )
        }
      }
    